 import {getEvents} from'../Service/Api'  
import Slider from "react-slick";
import LazyLoad from "react-lazyload";
 import { useEffect, useState } from 'react';  
const Events = () => {
  const [data,setData] = useState([]);
const [loading,setLoading] = useState(true);
const [error,setError] = useState(null);
const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
 useEffect(() => {
     const fetchData = async () =>{
          try{
            const result = await getEvents();
            setData(result);

          } catch {
            setError(error)
          }finally{
            setLoading(false)
          }

     }
fetchData();
 },[]);

 const empty = [
     { title:"Stay tunned for more Updates",date:"DD.MM.YY",venue:"school Campus",time:"00:00"},
     { title:"Stay tunned for more Updates",date:"DD.MM.YY",venue:"school Campus",time:"00:00"},
     { title:"Stay tunned for more Updates",date:"DD.MM.YY",venue:"school Campus",time:"00:00"},
 ]  
    var settings = {
        autoplay: true,
        infinite: true,
        autoplaySpeed: 2000,
        speed: 1000,
        slidesToShow:3,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false, 
        adaptiveHeight: true,
        responsive: [
            {
              breakpoint: 1300,
              settings: {
                slidesToShow: 2,
                slidesToScroll:1,
              }
            },
            {
                breakpoint: 1070,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll:1,
                }
              },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll:1,
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow:2,
                slidesToScroll: 1,
                initialSlide: 1
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
      };
   
 

    return (
        <Slider className='owl-theme' loop margin={10} {...settings}>
         
          {data && data.length > 0 ?  (data.map((item,index) => {
            const eventdate = new Date(item.date);
            const day = eventdate.getDate();
            const month = monthNames[eventdate.getMonth()]; 
          return (
       <div className="item" key={index}>
      <div className='evt-blk'>
          <div className="evt-img">
               <LazyLoad><img src={`https://webapi.entab.info/api/image/${item.images}`} className="img-fluid"/> </LazyLoad>
              <p> {day} {month}</p>
          </div>
          <div className='evt-content'> 
              <div className="evt-title"><h3>{item.title}</h3></div> 
              <div className="evt-desc"><h6>  {item.description}</h6></div> 
               <div className="event-bottom"> 
                  <p>{item.venue} </p>
                  <p> {item.time} </p>
               </div>
          </div>
      </div>
  </div>  
     ) })) :  (empty.map((item,index) => (
        <div className="item" key={index}>
                <div className='evt-blk'>
                    <div className="evt-img">
                        <img src="https://webapi.entab.info/api/image/MMATD/public/Images/events.jpg" /> 
                        <p>{item.date} </p>
                    </div>
                    <div className='evt-content'> 
                        <div className="evt-title"><h3>{item.title}</h3></div> 
                        <div className="evt-desc"><h6>  Stay Tunned for more Updates</h6></div> 
                         <div className="event-bottom"> 
                            <p>{item.venue} </p>
                            <p> {item.time} </p>
                         </div>
                    </div>
                </div>
            </div> 
     )))}    
        </Slider>
    );
};

export default Events;
